/// <amd-module name="Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/TestStepsUtils/ArrayUtils" />

// Based on code in Vssf\WebPlatform\Platform\Scripts\VSS\Utils\Array.ts

export class ArrayUtils {
    /**
     * @param array
     * @param item
     * @return
     */
    public static remove<T>(array: T[], item: T): boolean {
        var index = ArrayUtils.indexOf(array, item);
        if (index >= 0) {
            array.splice(index, 1);
        }
        return index >= 0;
    }

    /**
     * @param array
     * @param item
     * @return
     */
    public static indexOf<T>(array: T[], item: T): number {
        if (typeof item === "undefined") return -1;
        for (var i = 0, length = array.length; i < length; i++) {
            if (typeof array[i] !== "undefined" && array[i] === item) {
                return i;
            }
        }
        return -1;
    }

    /**
     * @param array
     * @return
     */
    public static clone<T>(array: T[]): T[] {
        if (array.length === 1) {
            return [array[0]];
        } else {
            return <T[]>Array.apply(null, array);
        }
    }
}
